export default __webpack_public_path__ + "static/media/banner_one.a1b42953.png";